import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-527e8437"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold grid-content" }, "Detail Catalog", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Information")
], -1))
const _hoisted_3 = { class: "px-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "Name", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "Product Code", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "Category", -1))
const _hoisted_7 = { class: "px-3" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Variants")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Artwork Template")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mockup")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Production")
], -1))
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Shipping")
], -1))
const _hoisted_20 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Variant = _resolveComponent("Variant")!
  const _component_DesignTemplate = _resolveComponent("DesignTemplate")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_sectionLayoutContent = _resolveComponent("sectionLayoutContent")!
  const _directive_hoist = _resolveDirective("hoist")!

  return (_openBlock(), _createBlock(_component_sectionLayoutContent, _mergeProps(_ctx.content, {
    backPageTitle: "Back",
    style: {"overflow":"hidden"}
  }), {
    default: _withCtx(() => [
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            class: "p-2.5 w-full create-catalog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { md: 24 }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            class: "mt-3 create-catalog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { md: 18 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, null, {
                            header: _withCtx(() => [
                              _hoisted_2
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 4 }, {
                                      default: _withCtx(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 20 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.catalog.name), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_divider),
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 4 }, {
                                      default: _withCtx(() => [
                                        _hoisted_5
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 20 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.catalog.productCode), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_divider),
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 4 }, {
                                      default: _withCtx(() => [
                                        _hoisted_6
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 20 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.catalog.categories?.map(item => item.title).join(', ')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_divider)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, { class: "mt-3" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_tabs, {
                                      modelValue: _ctx.activeName,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
                                      class: "demo-tabs"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_tab_pane, {
                                          label: "Overview",
                                          name: "description"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_col, {
                                              span: 24,
                                              style: {"text-align":"justify !important"}
                                            }, {
                                              default: _withCtx(() => [
                                                _withDirectives(_createElementVNode("template", {
                                                  innerHTML: _ctx.catalog.description
                                                }, null, 8, _hoisted_8), [
                                                  [_directive_hoist]
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "Description",
                                          name: "description2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_row, { gutter: 20 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _withDirectives(_createElementVNode("template", {
                                                      innerHTML: _ctx.catalog.description2
                                                    }, null, 8, _hoisted_9), [
                                                      [_directive_hoist]
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "Size Guide",
                                          name: "sizeGuide"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_row, { gutter: 20 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _withDirectives(_createElementVNode("template", {
                                                      innerHTML: _ctx.catalog.sizeGuide
                                                    }, null, 8, _hoisted_10), [
                                                      [_directive_hoist]
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "Shipping Detail",
                                          name: "shippingDetail"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_row, { gutter: 20 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _withDirectives(_createElementVNode("template", {
                                                      innerHTML: _ctx.catalog.shippingDetail
                                                    }, null, 8, _hoisted_11), [
                                                      [_directive_hoist]
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "Print Guide",
                                          name: "printGuide"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_row, { gutter: 20 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _withDirectives(_createElementVNode("template", {
                                                      innerHTML: _ctx.catalog.printGuide
                                                    }, null, 8, _hoisted_12), [
                                                      [_directive_hoist]
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "Service",
                                          name: "service"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_row, { gutter: 20 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _withDirectives(_createElementVNode("template", {
                                                      innerHTML: _ctx.catalog.service
                                                    }, null, 8, _hoisted_13), [
                                                      [_directive_hoist]
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, { class: "mt-3" }, {
                            header: _withCtx(() => [
                              _hoisted_14
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Variant, {
                                colors: _ctx.catalog.colors,
                                sizes: _ctx.catalog.sizes,
                                values: _ctx.catalog.variants,
                                productCode: _ctx.catalog.productCode,
                                designs: _ctx.catalog.designs,
                                catalogType: _ctx.catalog.type
                              }, null, 8, ["colors", "sizes", "values", "productCode", "designs", "catalogType"])
                            ]),
                            _: 1
                          }),
                          (_ctx.catalog.type === 'pod')
                            ? (_openBlock(), _createBlock(_component_el_card, {
                                key: 0,
                                class: "mt-3"
                              }, {
                                header: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_DesignTemplate, {
                                    dataSet: _ctx.catalog.designs
                                  }, null, 8, ["dataSet"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 6,
                class: "pl-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, null, {
                            header: _withCtx(() => [
                              _hoisted_16
                            ]),
                            default: _withCtx(() => [
                              (_ctx.catalog.mockupGallery?.length > 0)
                                ? (_openBlock(), _createBlock(_component_UploadImage, {
                                    key: 0,
                                    permission: "read",
                                    multiple: true,
                                    title: "",
                                    setData: _ctx.catalog,
                                    data: _ctx.catalog.mockupGallery,
                                    onCallback: _ctx.callbackMockup
                                  }, null, 8, ["setData", "data", "onCallback"]))
                                : (_openBlock(), _createBlock(_component_el_empty, {
                                    key: 1,
                                    "image-size": 80,
                                    description: "No data"
                                  }))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, { class: "mt-3" }, {
                            header: _withCtx(() => [
                              _hoisted_17
                            ]),
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("template", {
                                innerHTML: _ctx.catalog.production
                              }, null, 8, _hoisted_18), [
                                [_directive_hoist]
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, { class: "mt-3" }, {
                            header: _withCtx(() => [
                              _hoisted_19
                            ]),
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("template", {
                                innerHTML: _ctx.catalog.shipping
                              }, null, 8, _hoisted_20), [
                                [_directive_hoist]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}